import {featureFlag} from 'app/featureFlags/featureFlags';

interface IEarlyAccessFeature extends featureFlag {
  consent: string;
  onUpdateConsent: (consentChange: Record<string, string>) => void;
}

class EarlyAccessFeature implements IEarlyAccessFeature {
  name: string;
  slug: string;
  availableUntil: Date | number;
  consent: string;
  onUpdateConsent: (consentChange: Record<string, string>) => void;

  constructor(feature: featureFlag, consent: string, updateConsent: (consentChange: Record<string, string>) => void) {
    this.name = feature.name;
    this.slug = feature.slug;
    this.availableUntil = feature.availableUntil;
    this.consent = consent;
    this.onUpdateConsent = updateConsent;
  }

  updateConsent(consent: string): void {
    this.consent = consent;
    this.onUpdateConsent({[this.slug]: consent});
  }
}

export default EarlyAccessFeature;
